import { createAction, props } from '@ngrx/store';
import { Lookup } from '../models/lookup.model';
import { Study } from '../models/study.model';
import { StudyDatabase } from '../models/studyDatabase.model';

export const loadStudy = createAction('[Study Resolver] Load Study', props<{ id: number }>());

export const studyLoaded = createAction('[Load Study Effect] Study Loaded', props<{ study: Study }>());

export const updateStudy = createAction('[Study Edit Component] Update Study', props<{ study: Study }>());

export const updateStudyDatabases = createAction('[Search Strategy Component] Update Study Databases', props<{ studyDatabases: StudyDatabase[] }>());

export const setStudyDatabases = createAction('[Study Strategy Results Component] Set Study Databases', props<{ studyDatabases: StudyDatabase[] }>());

export const clearCachedComparables = createAction('[Search Strategy Component] Clear Cached Comparables');

export const leaveStudy = createAction('[Study Parent Component On Destroy] Leave Study');

export const loadStudyFilters = createAction('[Add Filter Dialog Component] Load Study Filters');

export const studyFiltersLoaded = createAction('[Study Effects] Study Filters Loaded', props<{ filters: Lookup[] }>());

export const invalidateStudyFilters = createAction('[Search Strategy Component] Invalidate Study Filters');
